import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type GetSettingsOptions = {
  listingId: string;
  type?: 'ackTemplate' | string;
};

const getSettings = async ({ listingId, type }: GetSettingsOptions) => {
  const config: AxiosRequestConfig = {
    url: '/covid19/settings',
    method: 'get',
    params: {
      listingId,
      type,
    },
  };

  const { data } = await axios.request<string>(config);

  return data;
};

export default getSettings;
